import { combineReducers } from "redux";
import genericReducer from './Generic/genericReducer';
import profileReducer from "./Profile/profileReducer";
import supportReducer from "./Support/supportReducer";
import subscriptionReducer from "./Subscription/subscriptionReducer";
import adminReducer from "./Admin/adminReducer";
import customerReducer from "./Customer/customerReducer";
import peopleReducer from './People/peopleReducer';
import collabReducer from "./collab/collabReducer";
import registerReducer from './Registration/registerReducer';

const rootReducer = combineReducers({
  generic: genericReducer,
  support: supportReducer,
  profile: profileReducer,
  subscription: subscriptionReducer,
  admin: adminReducer,
  customer: customerReducer,
  people: peopleReducer,
  collab: collabReducer,
  registration: registerReducer,
});

export default rootReducer;
